export default __webpack_public_path__ + "static/media/invoice.e3235372.png";